import React from 'react';
import styled from 'styled-components';

import { toast as ReactToast } from 'react-toastify';
import Images from '../../constants/ImageConstants';
import ColorConstants from '../../constants/ColorConstants';
import { toast } from '../../wrappers/toast/ToastWrapper';
import { Anchor } from '../base/Text';
import { TOAST_NOTIFICATIONS_DATA_AUTO_TEST_IDS } from './toast-notifications.contants';

const defaultProps = {
    link: null,
};

const backgroundsByType = {
    error: ColorConstants.salmon,
    success: ColorConstants.padua,
    warning: ColorConstants['regal-blue-50%'],
};


// TODO: https://github.com/paretogroup/quantic-spa/issues/545
const ToastNotification = ({
    // eslint-disable-next-line react/prop-types
    type, message, className, link,
}) => (
    <Wrapper
        background={backgroundsByType[type]}
        className={className}
        data-auto-testid={TOAST_NOTIFICATIONS_DATA_AUTO_TEST_IDS.TOAST_COMPONENT}
    >
        <Logo src={Images.LOGOS.PARETO_WHITE.SRC} />
        {link ? <Anchor href={link}><Message>{message}</Message></Anchor>
            : <Message>{message}</Message>}
    </Wrapper>
);

ToastNotification.defaultProps = defaultProps;

const Logo = styled.img`
    border-radius: 50%;
    height: 46px;
    width: 46px;
`;

const Message = styled.p`
    color: ${ColorConstants.white};
    font-size: 15px;
    font-weight: 400;
    margin: 0 0 0 10px;
    width: 285px;
`;

const Wrapper = styled.div`
    align-items: center;
    background: ${({ background }) => background};
    border-radius: 6px;
    display: flex;
    height: fit-content;
    min-height: 93px;
    padding: 18px;
    width: 400px;
`;

const TOAST_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
};


const dismissToast = (toastId) => {
    if (ReactToast.isActive(toastId)) {
        ReactToast.dismiss(toastId);
    }
};

const showToast = (
    message,
    type = TOAST_TYPE.SUCCESS,
    options = {},
    Component = ToastNotification,
    link,
) => {
    ReactToast.isActive(options.toastId);
    return toast(<Component
        message={message}
        type={type}
        link={link}
    />, options);
};

const showToastWithTimeout = ({
    message,
    type = TOAST_TYPE.SUCCESS,
    options = {},
    Component = ToastNotification,
    callback = () => { },
    timeout = 1000,
}) => {
    callback();
    setTimeout(() => {
        toast(<Component
            message={message}
            type={type}
        />, options);
    }, timeout);
};

const getToastMessageFromException = (messages, defaultMessage, exception) => {
    const exceptionMessage = typeof exception === 'object' ? JSON.stringify(exception) : String(exception);

    const messageKeysFromPossibleMatchErrors = Object.keys(messages || {}).filter(
        message => String(exceptionMessage).toLowerCase().includes(
            String(message).toLowerCase(),
        ),
    );

    const messageKey = messageKeysFromPossibleMatchErrors[0];

    return messages[messageKey] ? messages[messageKey] : defaultMessage;
};

const showToastFromException = (
    messages,
    defaultMessage,
    exception,
    Component = ToastNotification,
    toastComponent = toast,
) => {
    toastComponent(<Component
        message={getToastMessageFromException(messages, defaultMessage, exception)}
        type={TOAST_TYPE.ERROR}
    />, {});
};

export {
    showToast,
    dismissToast,
    TOAST_TYPE,
    showToastWithTimeout,
    showToastFromException,
};

export default ToastNotification;
